import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const subtitle = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
});

export const listContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '1x',
});

export const emptyState = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6x',
  textAlign: 'center',
});

export const emptyStateTitle = css({
  fontSize: 'lg',
  fontWeight: '600',
  color: 'hpxBlue600',
  marginBottom: '1x',
});

export const emptyStateText = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
});

export const signInButton = css({
  marginTop: '2x',
});
